import { post } from '../request'

/**
 * 会员分析相关API
 */

/**
 * 获取会员分析数据
 * @param {Object} params - 查询参数
 * @param {string} params.startTime - 开始时间，格式：yyyy-MM-dd HH:mm:ss
 * @param {string} params.endTime - 结束时间，格式：yyyy-MM-dd HH:mm:ss
 * @param {string} [params.compareStartTime] - 对比开始时间（用于同比分析），格式：yyyy-MM-dd HH:mm:ss
 * @param {string} [params.compareEndTime] - 对比结束时间（用于同比分析），格式：yyyy-MM-dd HH:mm:ss
 * @param {number} [params.lostDays=30] - 流失天数阈值，默认30天
 */
export function getMemberAnalysis(params) {
  return post('/chart/member/analysis', params)
}

// 添加默认导出
export default {
  getMemberAnalysis
}
